import React, { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { State } from "../../../../../state/store";
import { getAllAlertsAction,  } from "../../../../../state/usecase/admin/care_recipient/actions";
import useAlerts from "../../../../hooks/admin/care_recipient/useAlerts";
import { Loading } from "../../../common/Loading";
import { AlertsTableBody } from "./AlertsTableBody";
import { AlertsTableHead } from "./AlertsTableHead";

export const AlertsTable = React.memo(function AlertsTable(props: { maxShowAlertCount: number }) {
    const dispatch = useDispatch();

    const { alerts, displayAlertsPage } = useAlerts();

    const { maxShowAlertCount } = props;

    const displayAlerts = useMemo(() => {
        const start = displayAlertsPage * maxShowAlertCount;
        const end = start + maxShowAlertCount;
        return alerts?.slice(start, end) ?? [];
    }, [alerts, displayAlertsPage, maxShowAlertCount]);

    const processingCount = useSelector((state: State) => state.adminCareRecipient.processingAlerts);

    const processing = useMemo(() => processingCount > 0, [processingCount]);

    const noData = useMemo(() => !processing && (!displayAlerts || !displayAlerts.length), [processing, displayAlerts]);

    useEffect(() => {
        dispatch(getAllAlertsAction({}));
    }, [dispatch]);

    if (processing) return <Loading />;

    if (noData) return <div>アラートはありません</div>;

    return (
        <table className={"alert_list"}>
            <AlertsTableHead />
            <AlertsTableBody alerts={displayAlerts} />
        </table>
    );
});
